import { NOSWebClass, NOSConcurrentUploader, NOSBlockUploader, NOSDefaultUploader } from '@winman-f2e/nos-js-web';
import throttle from 'lodash/throttle';
import { config } from 'env_def';
import { isWebmail } from '../../../config';
export function getLocationOrigin() {
    if (typeof window !== 'undefined') {
        return location.origin;
    }
    return '';
}
export function getUploadApi() {
    let origin = process.env.BUILD_ISELECTRON ? config('webMailBJHost') : getLocationOrigin();
    origin = origin.endsWith('/') ? origin.replace(/\/$/, '') : origin;
    if (!isWebmail() && !process.env.BUILD_ISELECTRON) {
        origin += '/nos';
    }
    return origin;
}
export const uploadApi = getUploadApi();
export const sliceLen = 3 * 1024 * 1024;
class CustomUploader extends NOSConcurrentUploader {
    constructor() {
        super(...arguments);
        this.blockSize = sliceLen;
    }
    abort() {
        var _a;
        (_a = this.storage) === null || _a === void 0 ? void 0 : _a.remove(this.fileKey);
        return super.abort();
    }
}
export class NosUploadHelper {
    constructor(type) {
        this.NOSUploader = new NOSWebClass(NOSDefaultUploader);
        this.errorMap = {
            100: '获取 token 失败',
            1000: 'defaultUploader 上传失败',
            2000: 'blockUploader 重试过多，上传失败',
            2001: 'blockUploader 获取上次上传进度失败',
            3000: 'concurrentUploader 获取 uploadId 失败',
            3001: 'concurrentUploader 获取分片 md5 失败',
            3002: 'concurrentUploader 分片完成后，合并分片失败',
            3003: 'concurrentUploader 重试次数过多',
        };
        if (type === 'block') {
            this.NOSUploader = new NOSWebClass(NOSBlockUploader);
        }
        else if (type === 'concurrent') {
            this.NOSUploader = new NOSWebClass(CustomUploader);
            this.NOSUploader.updateAPI({
                NOS_CONCURRENT_UPLOAD: {
                    url: `${uploadApi}/{bucketName}/{objectKey}`,
                },
            });
        }
    }
    upload(config) {
        const { file, nosConfig, complete, progress, error } = config;
        this.NOSUploader.useGetToken(async () => nosConfig);
        const task = this.NOSUploader.createUploadTask(file);
        task.addListener('progress', throttle(() => {
            console.log('uploadHelper uploadProgress', task.uploadInfo);
            if (progress) {
                progress(task.uploadInfo);
            }
        }, 500, { leading: true, trailing: true }));
        task.addListener('complete', () => {
            console.log('uploadHelper uploadComplete', task.uploadedInfo);
            if (complete) {
                complete(task.uploadedInfo);
            }
        });
        task.addListener('error', () => {
            console.log('uploadHelper uploadError', task.uploadError);
            if (error && task.uploadError) {
                const { code } = task.uploadError;
                const msg = this.errorMap[code] || '上传失败';
                error(msg, code);
            }
        });
        task.upload();
        return task;
    }
}
